import { render, staticRenderFns } from "./BalancoContainer.vue?vue&type=template&id=2dba0d0c&scoped=true"
import script from "./BalancoContainer.vue?vue&type=script&lang=js"
export * from "./BalancoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba0d0c",
  null
  
)

export default component.exports